export const PROGRESS_ENDPOINT = `https://${process.env.NEXT_PUBLIC_PROGRESS_GATEWAY_DOMAIN_NAME}`;
